"use client";
import { IBlocks } from "@/types";
import React from "react";
import { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockSpotify({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const match = blockUpdate.url.match(
        /spotify\.com\/(track|album|artist|playlist)\/([^\/?]+)/
    );
    const type = match ? match[1] : null;
    const id = match ? match[2] : null;
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Spotify - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            {type && id ? (
                <iframe
                    id="spotify"
                    style={{ borderRadius: "12px" }}
                    src={`https://open.spotify.com/embed/${type}/${id}?utm_source=generator&theme=0`}
                    width="100%"
                    height="152"
                    frameBorder="0"
                    allowFullScreen={false}
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    className={"block-" + block.id}
                />
            ) : (
                <SpotifySkeleton />
            )}
        </AdminPopover>
    );
}

function SpotifySkeleton({ height = 152 }: { height?: number }) {
    return (
        <div
            className="flex items-center gap-4 bg-black/20 p-2"
            style={{ height, borderRadius: "12px" }}
        >
            <Skeleton
                className="flex-shrink-0 rounded-md"
                style={{ width: height, height }}
            />
            <div className="flex flex-1 flex-col gap-2 self-start">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
            </div>
        </div>
    );
}
